import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  sendEmailBuyerEmailAddress: {
    description: 'Automation Rules Send an Email - Buyer Email Address',
    defaultMessage: 'Buyer Email Address - [Buyer Email Address]',
    id: 'N8OVCp',
  },
  sendEmailStoreEmailAddress: {
    description: 'Automation Rules Send an Email - Store Email Address',
    defaultMessage: 'Store Email Address - [Store Email Address]',
    id: 'DiRn1m',
  },
});

export default [
  {
    displayName: <FormattedMessage {...messages.sendEmailBuyerEmailAddress} />,
    parameter: '[Buyer Email Address]',
  },
  {
    displayName: <FormattedMessage {...messages.sendEmailStoreEmailAddress} />,
    parameter: '[Store Email Address]',
  },
];
